export { default as Img200 } from './processed/200/Legion-S2.jpg';
export { default as Img400 } from './processed/400/Legion-S2.jpg';
export { default as Imgthumb } from './processed/thumb/Legion-S2.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Legion-S2.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Legion-S2.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      40,
      156,
      207
    ],
    "_population": 1247,
    "_hsl": [
      0.5508982035928144,
      0.6761133603238867,
      0.4843137254901961
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      4,
      82,
      146
    ],
    "_population": 14,
    "_hsl": [
      0.5751173708920188,
      0.9466666666666669,
      0.2941176470588235
    ]
  },
  "Muted": {
    "_rgb": [
      114,
      92,
      150
    ],
    "_population": 38,
    "_hsl": [
      0.7298850574712644,
      0.23966942148760334,
      0.4745098039215686
    ]
  },
  "DarkMuted": {
    "_rgb": [
      71,
      51,
      112
    ],
    "_population": 24,
    "_hsl": [
      0.7213114754098361,
      0.37423312883435583,
      0.3196078431372549
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Legion-S2.js